<template>
  <div>
    <div class="overlay-info" v-if="showInfo">
      <div class="bg-overlay" @click="toggleInfo"></div>
      <div class="bginfo">
        <img src="../assets/imgs/mision/bg-objetivo.png" alt="Encauce" />
        <div class="texto blanco" v-html="info"></div>
        <div class="close" @click="toggleInfo">
          <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
            <g id="cross">
              <line class="cls-1" x1="7" x2="25" y1="7" y2="25" />
              <line class="cls-1" x1="7" x2="25" y1="25" y2="7" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info", "showInfo"],
  data() {
    return {};
  },
  methods: {
    toggleInfo(){
      this.$emit('toggleInfoC')
    }
  },
};
</script>

